export const actions = {
  dashboard: 'Dashboard',
  lessons: 'Listă lecții',
  categories: 'Categorii',
  users: 'Utilizatori',
}
